import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Menu } from '@opendate-app/setlist';
import { CoinsHand, Columns03, DotsHorizontal, Plus } from '@untitled-ui/icons-react';

import ExportCSV from './ExportCSV';
import TableSettings from '../../shared/components/TableSettings';

const RecentOrdersHeader = ({
  csvDataSource,
  csvQuery,
  team,
  confirm,
  currentUser,
  visibleColumns,
  hiddenColumns,
  onColumnsChange,
  onResetColumns
}) => {
  const [tableSettingsOpen, setTableSettingsOpen] = useState(false);

  return (
    <div className="d-flex align-items-center justify-content-between recent-orders-header-row">
      <h6 style={{ fontWeight: 700, fontSize: 16, margin: 0, color: 'var(--sl-text-primary, #101828)' }}>
        Recent Orders
      </h6>
      <div className="d-flex align-items-center" style={{ gap: 8 }}>
        <ExportCSV csvDataSource={csvDataSource}
                   csvQuery={csvQuery}
                   team={team}
                   confirm={confirm} />
        <div style={{ position: 'relative' }}>
          <Button variant="secondary"
                  size="sm"
                  icon={Columns03}
                  onClick={() => setTableSettingsOpen((open) => !open)}>
            {hiddenColumns.length > 0 ? `Columns · ${hiddenColumns.length} hidden` : 'Columns'}
          </Button>
          <TableSettings isOpen={tableSettingsOpen}
                         onClose={() => setTableSettingsOpen(false)}
                         visibleFields={visibleColumns}
                         hiddenFields={hiddenColumns}
                         onFieldsChange={onColumnsChange}
                         onResetToDefault={onResetColumns} />
        </div>
        {currentUser.can_manage_refunds && (
          <Menu placement="bottom-end"
                trigger={<Button variant="secondary" size="sm" icon={DotsHorizontal} aria-label="More order actions" />}
                items={[{
                  label: 'Issue Multiple Refunds',
                  icon: CoinsHand,
                  onClick: () => { window.location.href = `/teams/${team.id}/confirms/${confirm.id}/bulk_refunds/new`; }
                }]} />
        )}
        <Button variant="primary"
                size="sm"
                icon={Plus}
                onClick={() => { window.location.href = `/teams/${team.id}/confirms/${confirm.id}/attendees`; }}>
          Add Attendees
        </Button>
      </div>
    </div>
  );
};

RecentOrdersHeader.propTypes = {
  csvDataSource: PropTypes.string.isRequired,
  csvQuery: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  visibleColumns: PropTypes.array.isRequired,
  hiddenColumns: PropTypes.array.isRequired,
  onColumnsChange: PropTypes.func.isRequired,
  onResetColumns: PropTypes.func.isRequired
};

export default RecentOrdersHeader;
